<div class="p-0 d-flex flex-wrap flex-column justify-content-around align-items-center rounded">
  <!-- Not Owner Barcode Body -->
  <div class="w-100 barcode-content-container bg-primary text-white">
    <div class="barcode-content mx-3 pb-3">
      <div class="d-flex align-items-center barcode-details" *ngIf="card$ | async as card">
        <!--Name and ID-->
        <div class="barcode-name">
          <h5 class="mb-1 card-name" *ngIf="memberDetails$ | async as memberDetails">
            {{ 'home.nav.welcome' | translate }} {{ memberDetails.FirstName }}
          </h5>
          <div class="font-size-14">{{ card.ExternalRefNumber }} - {{ 'member.card.id' | translate }}</div>
        </div>
        <button class="btn d-flex btn-wallet bg-glass-dark" [routerLink]="'/rewards/wallet'">
          <div class="icon material-symbols-outlined me-1">qr_code_scanner</div>
          <div class="text-white">{{ 'barcode.wallet.button' | translate }}</div>
        </button>
      </div>
      <!--Balances-->
      <div class="user-balances">
        <!--Points Balance-->
        <div class="balance-widget bg-glass-dark" [ngClass]="{ 'kids-balance': isKid }">
          <ng-container *notInPopulation="[population.Kids]">
            <div class="balance-details">
              <span class="icon material-icons">loyalty</span>
              <div class="balance">
                <h5 class="mb-0">{{ pointsBalance$ | async }}</h5>
                <div class="font-size-12 me-1">{{ 'member.card.points.balance' | translate }}</div>
              </div>
            </div>
          </ng-container>
          <ng-container *inPopulation="[population.Kids]">
            <div class="balance-details">
              <div class="font-size-12 me-1">{{ 'member.card.points.balance' | translate }}</div>
              <div class="balance">
                <span class="icon material-icons">loyalty</span>
                <h5 class="mb-0">{{ pointsBalance$ | async }}</h5>
              </div>
            </div>
          </ng-container>
        </div>
        <!--eCash Balance-->
        <ng-container *notInPopulation="[population.Kids]">
          <div class="balance-widget cursor-pointer bg-glass-dark" [routerLink]="'/hawksbucks'">
            <div class="balance-details">
              <span class="icon material-icons">loyalty</span>
              <div class="balance">
                <h5 class="mb-0">{{ ecash$ | async | FortressCurrencyPipe }}</h5>
                <div class="font-size-12 me-1">{{ 'member.card.ecash.balance' | translate }}</div>
              </div>
            </div>
          </div>
        </ng-container>
      </div>

      <ng-container *notInPopulation="[population.Kids]">
        <fgb-ecash-button></fgb-ecash-button>
      </ng-container>

      <div class="navigation-row-container" #scrollContainer>
        <div class="navigation-row">
          <div class="nav-widget" [routerLink]="'/rewards/marketplace'">
            <div class="w-100 d-flex justify-content-center">
              <div class="nav-icon icon material-symbols-outlined bg-glass-dark">redeem</div>
            </div>
            <div class="font-size-14">
              {{ 'nav.rewards' | translate }}
            </div>
          </div>

          <div class="nav-widget" [routerLink]="'/games'">
            <div class="w-100 d-flex justify-content-center">
              <div class="nav-icon icon material-symbols-outlined bg-glass-dark">stadia_controller</div>
            </div>
            <div class="font-size-14">
              {{ 'nav.games' | translate }}
            </div>
          </div>

          <div class="nav-widget" [routerLink]="'/challenges'">
            <div class="w-100 d-flex justify-content-center">
              <div class="nav-icon icon material-symbols-outlined bg-glass-dark">emoji_events</div>
            </div>
            <div class="font-size-14">
              {{ 'nav.challenges' | translate }}
            </div>
          </div>

          <ng-container *inPopulation="[population.Kids]">
            <div class="nav-widget" [routerLink]="'/worksheets'">
              <div class="w-100 d-flex justify-content-center">
                <div class="nav-icon icon material-symbols-outlined bg-glass-dark">tactic</div>
              </div>
              <div class="font-size-14">
                {{ 'nav.worksheets' | translate }}
              </div>
            </div>
          </ng-container>

          <ng-container *notInPopulation="[population.Kids]">
            <a class="nav-widget text-white" [routerLink]="'/guardians'">
              <div class="w-100 d-flex justify-content-center">
                <div class="nav-icon icon material-symbols-outlined bg-glass-dark">child_care</div>
              </div>
              <div class="font-size-14">
                {{ 'nav.kids' | translate }}
              </div>
            </a>
          </ng-container>

          <div class="nav-widget" [routerLink]="'/earn'">
            <div class="w-100 d-flex justify-content-center">
              <div class="nav-icon icon material-symbols-outlined bg-glass-dark">money</div>
            </div>
            <div class="font-size-14">
              {{ 'nav.earn' | translate }}
            </div>
          </div>

          <ng-container *notInPopulation="[population.Kids]">
            <div class="nav-widget" [routerLink]="'/payment'">
              <div class="w-100 d-flex justify-content-center">
                <div class="nav-icon icon material-symbols-outlined bg-glass-dark">credit_card</div>
              </div>
              <div class="font-size-14">
                {{ 'nav.hawks.pay' | translate }}
              </div>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</div>
